<div class="w-full flex flex-column align-items-center pb-3">
  <!-- Grid para Eventos em Destaque e Eventos da Semana lado a lado -->
  @if (featuredEvents().length > 0 || showWeeklyEvents()) {
    <div class="w-full px-2 md:px-3 lg:px-4 mt-4 md:mt-3" style="max-width: 1400px; overflow: visible;">
      <!-- justify-content-center: com uma seção só (Destaque OU Semana), o card
           fica centralizado em vez de encostado à esquerda. -->
      <div class="grid justify-content-center">
        <!-- Eventos em Destaque -->
        @if (featuredEvents().length > 0) {
          <div class="col-12 lg:col-6 p-2" style="overflow: visible;">
            <div class="w-full mb-2 px-2">
              <div class="flex align-items-center justify-content-center gap-2 mb-1 flex-wrap">
                <div class="all-events-icon flex align-items-center justify-content-center w-2rem h-2rem lg:w-3rem lg:h-3rem">
                  <i class="pi pi-star-fill text-base lg:text-lg"></i>
                </div>
                <h1 class="all-events-title text-xl lg:text-2xl font-bold m-0 line-height-1 cursor-pointer"
                  role="button" tabindex="0" (click)="setSection('featured')"
                  (keydown.enter)="setSection('featured')" (keydown.space)="setSection('featured')">
                  Eventos em Destaque
                </h1>
              </div>
              <div class="all-events-divider w-full border-round-sm" style="height: 2px;"></div>
            </div>
            <div class="w-full">
              <app-card-carousel section="featured"
                [events]="featuredEvents()"
                [numVisible]="1"
                [numScroll]="1"
               />
            </div>
          </div>
        }

        <!-- Eventos da Semana: só aparece com mais de 3 eventos -->
        @if (showWeeklyEvents()) {
          <div class="col-12 lg:col-6 p-2" style="overflow: visible;">
            <div class="w-full mb-2 px-2">
              <div class="flex align-items-center justify-content-center gap-2 mb-1 flex-wrap">
                <div class="all-events-icon flex align-items-center justify-content-center w-2rem h-2rem lg:w-3rem lg:h-3rem">
                  <i class="pi pi-clock text-base lg:text-lg"></i>
                </div>
                <h1 class="all-events-title text-xl lg:text-2xl font-bold m-0 line-height-1">Eventos da Semana</h1>
              </div>
              <div class="all-events-divider w-full border-round-sm" style="height: 2px;"></div>
            </div>
            <div class="w-full">
              <app-card-carousel section="weekly"
                [events]="weeklyEvents()"
                [numVisible]="1"
                [numScroll]="1"
               />
            </div>
          </div>
        }

      </div>
    </div>
  }

  @if (pagedEvents().length > 0) {
    <div class="w-full my-5 px-2" style="max-width: 1400px;">
      <div class="flex align-items-center justify-content-center gap-3 mb-3 flex-wrap">
        <div class="all-events-icon w-3rem h-3rem border-round-lg flex align-items-center justify-content-center">
          <i class="pi pi-calendar text-xl md:text-2xl"></i>
        </div>
        <h1 class="all-events-title text-3xl md:text-4xl font-bold m-0 line-height-1">Todos os Eventos</h1>
      </div>
      <div class="all-events-divider w-full border-round-sm"></div>
    </div>
  }
  
  <app-loading [show]="loading()" mode="inline" text="Buscando eventos..." subtext="Carregando as melhores experiências para você" />
  
  <div class="w-full px-3" style="max-width: 1400px;">
    <div class="grid">
      @for (item of pagedEvents(); track item.id || $index; let i = $index) {
        <div class="col-12 md:col-6 lg:col-4">
          <div class="p-2">
            <app-card-event [card]="{
                src: item.src,
                day: item.day ?? '00',
                title: item.title,
                month: item.month ?? '',
                city: item.city || '',
                state: item.state || '',
                local: item.local,
                description: item.description ? atobDecodific(item.description) : undefined
              }"
              width="100%"
              borderRadius="1.25rem"
              [id]="i"
              [route]="['/eventos/detalhe', item.slugUrl]"
             />
          </div>
        </div>
      }
    </div>
  </div>

  @if (totalEvents() >= 12) {
    <div class="w-full pt-4 flex justify-content-center">
      <p-paginator [rows]="pageSize()"
        [totalRecords]="totalEvents()"
        [rowsPerPageOptions]="[12, 24, 36]"
        [first]="first()"
        (onPageChange)="onPageChange($event)"
        dropdownAppendTo="body"
       />
    </div>
  }
</div>
